<template>
  <b-tabs content-class="mt-3">
    <b-tab title="Search"><CardFinder @cards-added="handleConfirm" /></b-tab>
    <b-tab title="Upload" lazy>
      <CardUploader v-if="userId && can.uploadCard" @card-created="handleConfirm" />
      <div v-else-if="!can.uploadCard && userId">
        <p class="lead">Upgrade to our Therapy Tools add-on to upload custom cards.</p>
        <b-button href="/pricing">Learn more</b-button>
      </div>
      <div v-else>
        <p class="lead">Join Ambiki to add custom cards to your visual schedule.</p>
        <b-button @click="showAuth">Sign up</b-button>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus } from '../event-bus';
import CardFinder from './CardFinder.vue';
import CardUploader from './CardUploader.vue';

export default {
  components: { CardFinder, CardUploader },

  computed: {
    ...mapState(['can', 'userId']),
  },

  methods: {
    handleConfirm() {
      this.$emit('close-modal');
    },

    showAuth() {
      EventBus.$emit('show-cta', true);
    },
  },
};
</script>
